import { PrimaryButton } from './ui.tsx';
import {
  INSTRUCTIONS_TITLE,
  PURPOSE_TEXT,
  WHY_PARTICIPATE_TEXT,
  WHO_SHOULD_COMPLETE,
  HOW_TO_COMPLETE_BASE,
  LIKERT_SCALE,
  RESPONSE_TIPS,
} from './instructions.ts';

/**
 * Its own step in the respondent flow — Login -> Instructions -> Assessment (section
 * index) — not a collapsible panel embedded in the section index. Shown once per survey
 * load (SurveyRunner defaults to this view for a first-time respondent; a returning
 * respondent with existing answers skips straight to the section index instead).
 */
export function InstructionsScreen({ onContinue }: { onContinue: () => void }) {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-ink">{INSTRUCTIONS_TITLE}</h1>

      <div className="mt-6 rounded-xl border border-black/8 bg-white p-5 text-sm text-ink-soft space-y-5">
        <div>
          <p className="font-semibold text-ink">Purpose of This Assessment</p>
          <p className="mt-1.5">{PURPOSE_TEXT}</p>
        </div>

        <div>
          <p className="font-semibold text-ink">Why You Are Being Asked to Participate</p>
          <p className="mt-1.5">{WHY_PARTICIPATE_TEXT}</p>
        </div>

        <div>
          <p className="font-semibold text-ink">Who Should Complete This Questionnaire</p>
          <ul className="mt-1.5 list-disc space-y-1 pl-5">
            {WHO_SHOULD_COMPLETE.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-semibold text-ink">How to Complete the Questionnaire</p>
          <ol className="mt-1.5 list-decimal space-y-1 pl-5">
            {HOW_TO_COMPLETE_BASE.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ol>
        </div>

        <div>
          <p className="font-semibold text-ink">Understanding the 5-Point Likert Scale</p>
          <ul className="mt-1.5 space-y-1.5">
            {LIKERT_SCALE.map((l) => (
              <li key={l.level}>
                <span className="font-medium text-ink">{l.level} = {l.tier}:</span> {l.description}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-semibold text-ink">Tips for Accurate Responses</p>
          <ul className="mt-1.5 list-disc space-y-1 pl-5">
            {RESPONSE_TIPS.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-6 flex justify-end">
        <PrimaryButton onClick={onContinue}>Continue to Assessment</PrimaryButton>
      </div>
    </div>
  );
}
